import { ColumnDef, DeepKeys, createColumnHelper } from '@tanstack/react-table'
import { Badge, Button } from 'reactstrap'
import { LookupOptions } from 'src/queries'
import { RelationshipsModalToggle } from './modals/Relationships'

type TData = LookupOptions[0]

const columnHelper = createColumnHelper<TData>()

type ModalToggleFunction = (id: string) => void

type LookupOptionColumns = (toggleEditModal?: ModalToggleFunction, toggleRelationshipModal?: RelationshipsModalToggle) => Array<ColumnDef<TData, DeepKeys<TData>>>

const columns: LookupOptionColumns = (toggleEditModal, toggleRelationshipModal) => [
  columnHelper.accessor((r) => {
    return typeof r.name === 'string' && r.name.trim() !== '' ? r.name : '(No Name)'
  }, {
    header: 'Name',
    id: 'name',
    cell: (info) => {
      const value = info.getValue()
      const id = info.row.original._id
      if (typeof id === 'string' && typeof toggleEditModal === 'function') {
        return (
          <Button
            color='link'
            onClick={() => {
              toggleEditModal(id)
            }}
          >
            {value}
          </Button>
        )
      }
      return value
    }
  }),
  columnHelper.accessor('_id', {
    header: 'Relationships',
    enableSorting: false,
    meta: {
      className: 'text-nowrap'
    },
    cell: (info) => {
      const relationships = info.row.original.relationships ?? []
      return (
        <>
          {relationships.map((relationship, index) => (
            <div
              className='d-flex my-1'
              key={index}
            >
              <Badge
                color='light'
                className='text-dark me-1'
                role='button'
                onClick={() => {
                  console.log('Relationship clicked:', {
                    relationshipModel: relationship.model,
                    optionId: info.row.original._id
                  })
                  if (typeof toggleRelationshipModal === 'function') {
                    if (typeof relationship.model === 'string' && typeof info.row.original._id === 'string') {
                      toggleRelationshipModal({
                        relationshipModel: relationship.model,
                        optionId: info.row.original._id
                      })
                      return
                    }
                    throw new Error('Invalid relationship model or option ID!')
                  }
                }}
              >
                <u>{relationship.count} {relationship.label}</u>
              </Badge>
            </div>
          ))}
        </>
      )
    }
  })
]

export { columns }
